import { render, staticRenderFns } from "./ReceptionComponent.vue?vue&type=template&id=3532f03c&"
import script from "./ReceptionComponent.vue?vue&type=script&lang=js&"
export * from "./ReceptionComponent.vue?vue&type=script&lang=js&"
import style0 from "./ReceptionComponent.vue?vue&type=style&index=0&id=3532f03c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QExpansionItem} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QExpansionItem})
